export default __webpack_public_path__ + "static/media/Swifter _ Seamless Authentication.ec19c130.png";